import $ from "jquery";
import { ucFirstAll } from "./utils";

function SelectFilter(el) {
    const $el = $(el);
    const $officeFilter = $el.find(".js-filter-office");
    const $businessFilter = $el.find(".js-filter-business");
    const $competenceFilter = $el.find(".js-filter-competence");
    const $searchInput = $el.find("#search-coworker");
    const $dropdownButton = $el.find(".archive-coworkers__button");
    const $dropdownList = $el.find(".archive-coworkers__list");

    const selectors = {
        office: "#office",
        business: "#business",
        competence: "#competence",
        searchCoworker: "#search-coworker",
    };

    let urlSearchParams = new URLSearchParams(window.location.search);
    let queryParams = Object.fromEntries(urlSearchParams.entries()) ?? {};

    function updateActiveValueFromQuery() {
        let { office, business, competence, coworker } = queryParams;

        $(selectors.office).text(ucFirstAll(office));
        $(selectors.business).text(ucFirstAll(business));
        $(selectors.competence).text(ucFirstAll(competence));
        $(selectors.searchCoworker).val(coworker);
    }

    updateActiveValueFromQuery();

    $dropdownButton.on("click", function () {
        const $currentList = $(this).next(".archive-coworkers__list");

        if ($(this).hasClass("archive-coworkers__button--active")) {
            $(this).removeClass("archive-coworkers__button--active");
            $currentList.removeClass("archive-coworkers__list--open");
            $currentList.attr("aria-expanded", false);
        } else {
            $dropdownButton.removeClass("archive-coworkers__button--active");
            $(this).addClass("archive-coworkers__button--active");

            $dropdownList.removeClass("archive-coworkers__list--open");
            $dropdownList.attr("aria-expanded", false);
            $currentList.addClass("archive-coworkers__list--open");
            $currentList.attr("aria-expanded", true);
        }
    });

    $(document).on("click", function (e) {
        const $shouldCloseDropdown =
            !$dropdownButton.is(e.target) &&
            $dropdownButton.has(e.target).length === 0;

        if ($shouldCloseDropdown) {
            $dropdownButton.removeClass("archive-coworkers__button--active");
            $dropdownList.removeClass("archive-coworkers__list--open");
            $dropdownList.attr("aria-expanded", false);
        }
    });

    function handleFilterClick($filter, paramName) {
        $filter.on("click", function () {
            const value = $(this).data("value");

            if (value) {
                queryParams[paramName] = value;
            } else {
                delete queryParams[paramName];
            }

            const $select = $el.find(selectors[paramName]);

            const $currentValue = $(this).text();
            $select.text($currentValue);

            $dropdownList.removeClass("archive-coworkers__list--open");

            filterCards();
            setQueryParams();
        });
    }

    handleFilterClick($officeFilter, "office");
    handleFilterClick($businessFilter, "business");
    handleFilterClick($competenceFilter, "competence");

    $searchInput.on("keyup", function () {
        const value = $el.find("#search-coworker").val().toLowerCase();

        if (value) {
            queryParams.coworker = value;
        } else {
            delete queryParams.coworker;
        }

        filterCards();
        setQueryParams();
    });

    function filterCards() {
        let $cards = $el.find(".card-coworker");
        let matchesFound = false;

        $cards.each(function () {
            const data = $(this).data("filter-value");
            const { office, business, competence, coworker } = data;

            let hasMatchedOffices =
                !queryParams.office || office.includes(queryParams.office);

            let hasMatchedBusiness =
                !queryParams.business ||
                business.includes(queryParams.business);

            let hasMatchedCompetence =
                !queryParams.competence ||
                competence.includes(queryParams.competence);

            let hasMatchedName =
                !queryParams.coworker ||
                coworker.includes(queryParams.coworker);

            if (
                hasMatchedOffices &&
                hasMatchedBusiness &&
                hasMatchedCompetence &&
                hasMatchedName
            ) {
                $(this).removeClass("card-coworker--hide");
                matchesFound = true;
            } else {
                $(this).addClass("card-coworker--hide");
            }
        });

        const $results = $el.find(".archive-coworkers__empty-results");

        if (!matchesFound) {
            $results.addClass("archive-coworkers__empty-results--visible");
        } else {
            $results.removeClass("archive-coworkers__empty-results--visible");
        }
    }

    function setQueryParams() {
        const queryString = $.param(queryParams);
        const url = queryString ? `?${queryString}` : window.location.pathname;
        window.history.pushState(null, "", url);
    }

    filterCards();
    setQueryParams();
}

export default SelectFilter;
